import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { FoundationContextProvider, SurfaceContextProvider } from '@cld/design-system-foundations';
import { createBlenderMappingForSelectionState } from './blenderMapping';
import { ButtonContent } from './ButtonContent';
import { buttonStyle } from './buttonStyle';
import { useFoundation, useLinkSurface } from './foundationMapping';
import { ButtonThemeProps, LinkBlenderProps, LinkButtonProps } from './types';

export const LinkButtonRoot = styled.a<ButtonThemeProps & LinkBlenderProps>`
  ${createBlenderMappingForSelectionState('unselected')};
  ${buttonStyle};
  &,
  &:hover {
    text-decoration: none;
  }
`;

export const LinkButton = forwardRef<HTMLAnchorElement, LinkButtonProps>(
  ({ size, shape = 'normal', variant, tone, isDisabled = false, leftSlot, rightSlot, children, tabIndex, ...rest }, ref) => {
    const surface = useLinkSurface({ tone, variant });
    const foundation = useFoundation({ size });

    return (
      <FoundationContextProvider {...foundation.innerContextProps}>
        <SurfaceContextProvider {...surface.innerContextProps}>
          <LinkButtonRoot
            data-test="link-button"
            aria-disabled={isDisabled}
            shape={shape}
            tabIndex={isDisabled ? -1 : tabIndex}
            {...surface.componentProps}
            {...foundation.componentProps}
            {...rest}
            ref={ref}
          >
            <ButtonContent size={foundation.componentProps.size} leftSlot={leftSlot} rightSlot={rightSlot}>
              {children}
            </ButtonContent>
          </LinkButtonRoot>
        </SurfaceContextProvider>
      </FoundationContextProvider>
    );
  }
);
